module.exports = __webpack_public_path__ + "static/media/YF18_2.5e656158.jpg";